<template>
  <v-app
    :style="
      $router.currentRoute.path.includes('/secretariat/') ||
      $router.currentRoute.path.includes('Chat') ||
      $router.currentRoute.path.includes('chat') ||
      $router.currentRoute.path.includes('videoCall')
        ? 'background-color: #ebebeb'
        : ''
    "
  >
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

@font-face {
  font-family: iransans;
  src: url("assets/fonts/IRANSans(FaNum).ttf");
}

body {
  font-family: iransans !important;
}
</style>
